import React from "react";
import { View, StyleSheet } from "react-native";
import BaseMarketingController from "./BaseMarketingController";
import NtMarketingPageContainer from "../components/general/NtMarketingPageContainer";
import NtHospitalitySection from "../components/hospitality/NtHospitalitySection";
import NtHospitalityBenefitSection from "../components/hospitality/NtHospitalityBenefitSection";
import NtIntegratedHotelSection from "../components/hospitality/NtIntegratedHotelSection";
import NtHospitalityFeatureSection from "../components/hospitality/NtHospitalityFeatureSection";
import NtHospitalityCoreFeatureSection from "../components/hospitality/NtHospitalityCoreFeatureSection";

class HospitalityController extends BaseMarketingController {
  state = {};
  render() {
    return (
      <NtMarketingPageContainer style={styles.container}>
        <NtHospitalitySection />
        <NtHospitalityBenefitSection />
        <NtIntegratedHotelSection showLearnMore={false} />
        <NtHospitalityFeatureSection />
        <NtHospitalityCoreFeatureSection />
      </NtMarketingPageContainer>
    );
  }
}

const styles = StyleSheet.create({
  container: {},
});

export default HospitalityController;
